import React from 'react';
import { MapPinIcon, PhoneIcon, MusicIcon } from 'lucide-react';
import { COMPANY, NAV_LINKS, waLink } from '../data/company';
export function Footer() {
  return <footer className="relative border-t border-gold/15 bg-ink-soft" data-id="element-84" data-mp="32nukakr5twzs">
      <div className="h-px w-full gold-hairline" data-id="element-85" data-mp="32pp7k5pwm171" />
      <div className="mx-auto max-w-7xl px-5 py-14" data-id="element-86" data-mp="36oy1baky1z2l">
        <div className="grid gap-10 md:grid-cols-3" data-id="element-87" data-mp="36ppnjusnikg7">
          <div data-id="element-88" data-mp="3uesczotj1hl9">
            <div className="flex items-center gap-2" data-id="element-89" data-mp="3ugbt9ff6nsn1">
              <span className="grid h-10 w-10 place-items-center rounded-lg gold-border bg-ink-card" data-id="element-90" data-mp="38qz78i6g9vx">
                <span className="font-display text-lg font-bold text-gold-gradient" data-id="element-91" data-mp="3lem127dh8po7">WP</span>
              </span>
              <span className="leading-tight" data-id="element-92" data-mp="3qcx9cdo4is4b">
                <span className="block font-display text-base font-semibold text-white" data-id="element-93" data-mp="3qblxrrofsg2n">WP Transport</span>
                <span className="block text-[10px] uppercase tracking-[0.25em] text-gold/80" data-id="element-94" data-mp="2a19tbleljmwr">Luxury Rental</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/55" data-id="element-95" data-mp="3l8qwa43iojrg">
              Rental mobil premium & terpercaya di Garut. Sewa mobil harian, bulanan, city tour,
              jemput bandara, wisata religi, dan lainnya.
            </p>
          </div>

          <div data-id="element-96" data-mp="3q8mypywkg34w">
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-gold" data-id="element-97" data-mp="3q83svgk6x578">Menu</h4>
            <ul className="mt-4 grid grid-cols-2 gap-2" data-id="element-98" data-mp="82ihs7hrf0lp">
              {NAV_LINKS.map(l => <li key={l.href} data-id="element-99" data-mp="34gxjj8lkv8n">
                  <a href={l.href} className="text-sm text-white/60 transition-colors hover:text-gold" data-id="element-100" data-mp="33e69a7d4qs7">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-101" data-mp="cvtlhzr9z19e">
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-gold" data-id="element-102" data-mp="qthzqoqu7a5h">Kontak</h4>
            <ul className="mt-4 space-y-3 text-sm text-white/60" data-id="element-103" data-mp="ms6hj4aalr7b">
              <li className="flex items-start gap-3" data-id="element-104" data-mp="mptqm1mk46i4">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-105" data-mp="tw5xq4ifnmlo" /> {COMPANY.address}
              </li>
              <li data-id="element-106" data-mp="yuzce09ghjnf">
                <a href={waLink('Halo, saya ingin bertanya.')} className="flex items-center gap-3 transition-colors hover:text-gold" data-id="element-107" data-mp="yuh60at2xp1s">
                  <PhoneIcon className="h-4 w-4 shrink-0 text-gold" data-id="element-108" data-mp="18jqznv3knfs0" /> {COMPANY.phoneDisplay}
                </a>
              </li>
              <li data-id="element-109" data-mp="1ckknypkxewlf">
                <a href={COMPANY.tiktokUrl} className="flex items-center gap-3 transition-colors hover:text-gold" target="_blank" rel="noopener noreferrer" data-id="element-110" data-mp="1cl2s08dtyf3w">
                  <MusicIcon className="h-4 w-4 shrink-0 text-gold" data-id="element-111" data-mp="1mj8twpzmzl8r" /> {COMPANY.tiktok}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6 text-center text-xs text-white/45" data-id="element-112" data-mp="1rgirwu13d587">
          © {new Date().getFullYear()} {COMPANY.name}. Seluruh hak cipta dilindungi.
        </div>
      </div>
    </footer>;
}